// extracted by mini-css-extract-plugin
export var center = "_52-2";
export var clickableRow = "_52-5";
export var expandedRow = "_52-7";
export var hoverable = "_52-4";
export var left = "_52-1";
export var right = "_52-3";
export var row = "_52-0";
export var selectedRow = "_52-6";
export var summaryRow = "_52-8";